import { Editor, getMarkRange, getMarkType } from '@tiptap/core'
import { MarkType } from '@tiptap/pm/model'

/**
 * Gets the full text behind the currently selected mark (e.g. the text of a link.)
 * For example, if you have the link "www.google.com" in your document, and you've
 * selected just "gle.com" with the cursor, this helper will return "www.google.com".
 *
 * @example
 * const label = getMarkText(editor, 'link')
 */
const getMarkText = (editor: Editor, nameOrType: string | MarkType): string => {
  let text = ''

  const { state } = editor
  const { $from, from, to } = state.selection
  const range = getMarkRange($from, getMarkType(nameOrType, state.schema))
  // If the expected mark is in the selection & has a valid range, use the
  // full range of the mark. Otherwise, just get all the text in the selection
  if (range && range.from <= from && range.to >= to) {
    text = state.doc.textBetween(range.from, range.to, ' ')
  } else {
    text = state.doc.textBetween(from, to, ' ')
  }

  return text
}

export default getMarkText
